import {
	request,
	requestPublic
} from './request.js'
import { isNumberBrowser } from '@/common/utils.js'
// 引入vuex
import store from '../store/index'

// 登录
export function logIn(userName, passWord,code) {
	let params = new URLSearchParams();
	params.append('grant_type', 'huihang_adminpassword');
	params.append('client_id', 'huihang-admin');
	params.append('client_secret', 'zsb.web.secret');
	params.append('loginName', userName);
	params.append('loginPwd', passWord);
	params.append('code', code);
	params.append('loginType',10)
	return requestPublic({
		url: '/api1/connect/token',
		method: 'post',
		data: params
	})
}
// export function loginRoleInformation() {
// 	return request({
// 		url: '/api4/SBCenterAdminApi/Admin/LoginRoleInformation',
// 		method: 'get',
// 	})
// }
// 获取管理员用户信息
export function loginRoleInformation() {
	return request({
		url: '/api2/ZsbSiteAdmin/Login/GetLoginInfo?a=' + Math.random(),
		method: 'get',
	})
}

// 未登录前 登陆获取配置信息
export function ApolloConfigForWeb() {
	return requestPublic({
		url: '/api2/AdminService/ApolloConfigForWeb',
		method: 'get',
	})
}

// 存储登录信息
export async function saveloginInfo(token, userInfo) {
	// 存储token
	store.commit('saveTokenStorage', token);
	store.commit('saveUserInfoStorage', userInfo);
	// 存储登录状态localStorage
	sessionStorage.setItem('isLogin', true)
	//存储token
	sessionStorage.setItem('token', JSON.stringify(token))
	// 修改登录状态
	store.commit('changeLoginState', true)
}

// 退出登录
export function logOut() {
	sessionStorage.removeItem('AdminCache');
	sessionStorage.removeItem('isLogin')
	sessionStorage.removeItem('store')
	sessionStorage.removeItem('isDelect')
	// store.commit('changeLoginState', false)
	store.dispatch('logout', false)
}
export function GetAdminSmsCode(obj) {
	return requestPublic({
		url: '/api2/ZsbSiteWeb/Server/GetAdminSmsCode',
		method: 'post',
		params:{
			userName:obj,
		}
	})
}

// 基于老师登录账号来判断用户是否同一Ip且在有效时间范围内的登陆
export function IsReLoginFromUserName(data) {
	// 用户浏览器名称 只返回360 其他为空
	let name = isNumberBrowser()
	return requestPublic({
		url: '/api2/ZsbSiteWeb/Server/IsReLoginFromUserName',
		method: 'get',
		params: {
			userName: data,
			userAgent: name
		}
	})
}
// 日志管理
export function GetLogs(obj) {
	return request({
		url: '/api2/ZsbSiteAdmin/Log/GetLogs',
        method: 'post',
        data: obj
	})
}
export function GetAdminLoginToken(data) {
	return requestPublic({
		url: '/api4/SBCenterWebApi/AdminLogin/GetAdminLoginToken',
		method: 'get',
		params: data,
	})
}
export function AdminLoginByRolesId(data) {
	return request({
		url: '/api4/SBCenterAdminApi/Admin/AdminLoginByRolesId',
		method: 'get',
		params: data,
	})
}